<template>
<div>

  <div class="modal fade" id="AssistantConfigModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content border border-primary">
      <div class="modal-header border border-primary  bg-secondary text-white" >
        <h5 class="modal-title" id="staticBackdropLabel">
          <i class="fas fa-cog mr-2" aria-hidden="true"></i>
          OPZIONI</h5>       
      </div>
      <div class="modal-body">
        <h5 style="color:blue"><strong>SHOPPING ASSISTANT</strong> </h5>       
        <div class="form-check">
          <input class="form-check-input" @click="setShoppingAssistantOption(1)"  type="radio" name="exampleRadios" id="exampleRadios1" value="1" :checked="option==1" v-model="option">
          <label class="form-check-label" for="exampleRadios1">
            <strong>PER OGNI RIGA CARRELLO</strong>
          </label>
        </div>
        <div class="form-check">
        <input class="form-check-input" @click="setShoppingAssistantOption(2)" type="radio" name="exampleRadios" id="exampleRadios2" value="2" :checked="option==2" v-model="option">
          <label class="form-check-label" for="exampleRadios2">
          <strong>AL TERMINA E PAGA</strong>
        </label>  
        </div>
        <div class="form-check">
        <input class="form-check-input" @click="setShoppingAssistantOption(0)" type="radio" name="exampleRadios" id="exampleRadios3" value="0" :checked="option==0" v-model="option">
        <label class="form-check-label" for="exampleRadios3">
        <strong>DISABILITATA</strong>
        </label>  
        </div>
        <h5 style="color:blue" class="mt-2"><strong>ASSISTENTE VOCALE</strong> </h5>       
        <div style="color:black" class="form-check " >
            <input  @change="setVocalMsg()" class="form-check-input" type="checkbox" id="defaultCheck1" v-model="vocalMsg">
              <label class="form-check-label" for="defaultCheck1">
                <strong>ATTIVO</strong>
              </label>
        </div>                  
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>


</div>

</template>

<script>


export default {

   props : [],
   
   
  components: {},
  data() {
    return {
            
      option : 0,
      vocalMsg : 0
      
    };
  },

    
  mounted :function() {

    
    const option = JSON.parse(localStorage.getItem("ShoppingAssistantOption"))
    const vocalMsg = JSON.parse(localStorage.getItem("vocalMsg"))
    
    if(option)
    {
      this.option = option
    }
    if(vocalMsg)   
    {
      this.vocalMsg = vocalMsg
    }
  },
  created : function()
  {
    this.$nextTick(()  => {                  
        $('#AssistantConfigModal').modal('show')
        $('#AssistantConfigModal').on('hidden.bs.modal', (event) =>  {
            this.$emit('update',false,this.option)
      })
    })  
  },
  methods: 
  {
    setVocalMsg()
    {
      console.log(this.vocalMsg)
      localStorage.setItem('vocalMsg',JSON.stringify(this.vocalMsg))
    },
    setShoppingAssistantOption(option)
    {
     
      localStorage.setItem('ShoppingAssistantOption',JSON.stringify(option))
      
      
    }
    
    

}

}
</script>
<style scoped>
.form-check-label {
  cursor: pointer;
}
</style>


